import Vue from 'vue'

import Cookies from 'js-cookie'

import 'echarts/theme/macarons'
import Element from 'element-ui'
import './styles/element-variables.scss'
import locale from 'element-ui/lib/locale/lang/en'

import '@//styles/index.scss' // global css
import '@//styles/common.scss' // common css
import 'quill/dist/quill.snow.css' // rich-text notification content
import App from './App.vue'
import store from './store'
import router from './router'

import './icons' // icon
import './permission' // permission control
import './utils/error-log' // error log
import * as filters from './filters' // global filters
import { captureAttribution } from './utils/attribution' // 注册来源（utm/referrer）

import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import VueClipboard from 'vue-clipboard2'
import Print from 'vue-print-nb'


Vue.use(Viewer)
Vue.use(Print);

Vue.use(Element, {
  size: Cookies.get('size') || 'medium', // set element-ui default size
  locale
})
VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)



// register global utility filters
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.config.productionTip = false

// 记录注册来源（utm_source/medium/campaign + referrer + 落地页），注册时随请求提交
captureAttribution()

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
